import { ISummary, ISummaryData } from './summary.types';

export class Summary implements ISummary {
    propsCount: number
    filledProps: number
    missingProps: Array<string>
    invalidProps: Array<string>

    constructor(summary: ISummaryData){
        this.propsCount = summary.propsCount || 0;
        this.filledProps = summary.filledProps || 0;
        this.missingProps = summary.missingProps || [];
        this.invalidProps = summary.invalidProps || [];
    }

    progress(): number{
        if(this.propsCount > 0) {
            return Math.round((this.filledProps / this.propsCount) * 100);
        } else {
            return 0
        }

    }


}